/** Discriminator for which visitor info disclaimer a route requires. */
export type VisitorInfoType = 'none' | 'funds' | 'publications';

/** Maps a visitorInfoType to its sessionStorage key. */
export const STORAGE_KEYS: Record<Exclude<VisitorInfoType, 'none'>, string> = {
  funds: 'visitorInfo',
  publications: 'publicationsVisitorInfo',
};

/** Returns the sessionStorage key for a given visitor info type, or null for 'none'. */
export function getStorageKey(type: VisitorInfoType): string | null {
  if (type === 'none') return null;
  return STORAGE_KEYS[type];
}
